import { Box, Typography } from "@material-ui/core";
import { Button, CircularProgress } from "@mui/material";

import ModalComponent from "../../criar-vitrine/incluir-produtos/components/modal";

export default function SelectionScopeModal({
  open,
  onClose,
  title,
  entityLabel = "registros",
  currentPageCount = 0,
  totalCount = 0,
  maxBulkSelect = 2000,
  loading = false,
  onCancel,
  onSelectCurrentPage,
  onSelectAllResults,
  showSelectAllResults = true,
}) {
  return (
    <ModalComponent
      open={open}
      onClose={onClose}
      width="520px"
      title={title}
    >
      <Typography variant="body2" color="textSecondary">
        Selecione a abrangência:
      </Typography>
      <Typography variant="body2" style={{ marginTop: 8 }}>
        - Página atual: {currentPageCount} {entityLabel}
        <br />- Todos os resultados: {totalCount} {entityLabel}
        {totalCount > maxBulkSelect ? (
          <>
            <br />
            (máximo {maxBulkSelect} por seleção em massa)
          </>
        ) : null}
      </Typography>
      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        style={{ gap: 12, marginTop: 20 }}
      >
        <Button
          variant="outlined"
          disabled={loading}
          onClick={onCancel}
          style={{ padding: 10 }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          disabled={loading}
          onClick={onSelectCurrentPage}
          style={{ padding: 10 }}
        >
          Somente página
        </Button>
        {showSelectAllResults ? (
          <Button
            variant="contained"
            disabled={loading}
            onClick={onSelectAllResults}
            style={{ padding: 10 }}
          >
            {loading ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              "Todos resultados"
            )}
          </Button>
        ) : null}
      </Box>
    </ModalComponent>
  );
}
